import lang from '@/lang'
import { PASSWORD_CHECK_RULES } from '@/config'

export interface PasswordRuleState {
  key: 'minLength' | 'upperAndLower' | 'digitOrSpecial'
  label: string
  met: boolean
}

// The chips of the new design, the same everywhere a password is set (onboarding, "Passwort eingeben",
// "Passwort vergeben"). Together they are exactly as strict as passwordStrengthPatterns
// (modules/account/config): the first of those also asks for a lower case letter plus an upper case
// letter or a digit - both already part of "Groß- und Kleinbuchstaben" - so the length is all that
// is left for "Mind. 8 Zeichen". They are stricter than config.passwordChecks[1], which the API
// accepts, so a password the chips accept is never rejected.
const RULES: Array<{ key: PasswordRuleState['key'], test: (password: string) => boolean }> = [
  { key: 'minLength', test: password => password.length >= 8 },
  { key: 'upperAndLower', test: password => PASSWORD_CHECK_RULES.charsMin1UpperAndLower.test(password) },
  { key: 'digitOrSpecial', test: password => PASSWORD_CHECK_RULES.charsMin1SpecialOrNumeric.test(password) },
]

export const getPasswordRuleStates = (password = ''): PasswordRuleState[] => RULES.map(({ key, test }) => ({
  key,
  label: lang.passwordRules[key],
  met: test(password),
}))

export const areAllPasswordRulesMet = (password = ''): boolean => getPasswordRuleStates(password).every(rule => rule.met)
